import React from "react";
import Header from "../Home/Header";
import Footers from "../Home/Footers";
import "./traineePortal.css";

export default function Trainee() {
  return (
    <div className="als-trainee-page">
      <Header />
      <div className="trainee-container" style={{ paddingTop: 48 }}>
        <div className="card-custom">
          <h2 className="section-heading" style={{ marginTop: 0 }}>
            Trainee
          </h2>
          <p style={{ margin: 0, color: "#6b7280" }}>
            Please sign in to access your learner dashboard.
          </p>
        </div>
      </div>
      <Footers />
    </div>
  );
}
